import { isFinite } from 'lodash-es';

/**
 * Converts distance in meters to human-readable string i.e. km if necessary
 * @param valueInMeters distance in meters
 */
export function humanizeDistance(valueInMeters: number): string | undefined {
    if (!isFinite(valueInMeters)) return undefined;

    // km
    if (valueInMeters >= 1000) {
        return `${Math.round(valueInMeters / 1000)}km`;
    }

    return `${Math.round(valueInMeters)}m`;
}
